import React from 'react';
import 'twin.macro';
import { Link } from 'gatsby';

import { Heading, Subtitle, Button } from '../atoms';
import SanityImage from '../global/SanityImage';

const ServiceCard = ({ data }) => {
  if (!data) return null;
  return (
    <div tw="rounded overflow-hidden shadow-lg bg-white flex flex-col">
      <SanityImage
        fluid={data.seoFeaturedImage.asset.gatsbyImageData}
        tw="w-full"
        alt={data.title}
      />
      <div tw="px-6 py-4">
        <Heading>{data.title}</Heading>
        <Subtitle>{data.description}</Subtitle>
      </div>
      <div tw="px-6 pb-6 mt-auto">
        {data.slug && (
          <Link to={`/service/${data.slug.current}`}>
            <Button>LEARN MORE</Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
